<template>
  <pt-points-reward-detail class="pt-points-reward-detail__page"></pt-points-reward-detail>
</template>

<script>
import PtPointsRewardDetail from 'cps/new-to-old-audit/pt-points-reward/pt-points-reward-detail/withData'
export default {
  name: 'pt-points-reward-detail__view',
  components: {
    'pt-points-reward-detail': PtPointsRewardDetail
  }
}
</script>
